
import { MDCLinearProgress } from '@material/linear-progress';
import { Vue, Prop, Watch } from 'vue-property-decorator';

export default class MaterialSwitch extends Vue {

    @Prop(Number) readonly progress!: number;
    @Prop(Boolean) readonly determinate!: boolean;

    private ctrl?: MDCLinearProgress;

    @Watch('progress')
    onProgressChanged(newVal: number, _: number) {
        if (!this.ctrl) return;
        this.ctrl.progress = newVal;
    }

    @Watch('determinate')
    onDeterminateChanged(newVal: boolean, _: boolean) {
        if (!this.ctrl) return;
        this.ctrl.determinate = newVal;
    }

    mounted() {
        this.ctrl = MDCLinearProgress.attachTo(this.$el);
        this.ctrl.progress = this.progress;
        this.ctrl.determinate = this.determinate;
    }

    unmounted() {
        this.ctrl?.close();
        this.ctrl?.destroy();
    }
}
